import Constants from 'constants/actions';

const defaultState = {
    amendmentData: {},
    selectedPax: {},
    initialisedData: {},
    cancellationData: {}
};

const myBooking = (state = defaultState, action) => {
    const { type = '', payload = {} } = action;
    switch (type) {
        case Constants.AMENDMENTS.BOOKING_AMENDMENT: {
            return {
                ...state,
                amendmentData: payload,
            }
        };
        case Constants.AMENDMENTS.INITIALISE: {
            return {
                ...state,
                initialisedData: payload,
            }
        };
    };

    return state;
}

export default myBooking
